import React, {
    useEffect,
    useState,
    useMemo, useContext,
} from 'react';

import PropTypes from 'prop-types';
import axios from "axios";
import AuthContext from "../AuthContext";
import CotizarContext from "./CotizarContext";

const CotizarContextProvider = ({
                                   children,
                               }) => {

    const [isReady, setIsReady] = useState(null)
    const [afinidades, setAfinidades] = useState(null)
    const [localidades, setLocalidades] = useState(null)
    const [afinidadesPic, setAfinidadesPic] = useState(null)
    const [coberturasInfo, setCoberturasInfo] = useState(null)
    const [autosModulos, setAutosModulos] = useState(null)
    const TR_ID_MODULOS = ['20', '18', '13', '9', '7', '8', '26', '28', '30', '31', '33', '35']
    const coveragesToFilter = ['38']
    const [dictModulosEmision, setDictModulosEmision] = useState({})
    const {authToken} = useContext(AuthContext)



    useEffect(() => {
        let shouldUpdate = true;
        //
        const init = async () => {

            let url = process.env.REACT_APP_BACK_SERVER + '/u/getDatosCotizar'

            axios.post(url, {origen: 'affinity'}, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${authToken}`
                }
            }).then((resp) => {
                if (shouldUpdate) {

                    let options = resp['data']['General_Localidades'].map(d => ({
                        "value": d.CodPostal.toString() + ',' + d.CodSancorLocalidad.toString(),
                        "label": '(' + d.CodPostal.toString() + ') ' + d.Localidad,
                        "zonaRiesgo": d.ZonaRiesgo
                    }));
                    setLocalidades(options)

                    let optionsAfinidades = resp['data']['General_Asesores_Afinidades'].map(d => ({
                        "value": d.Afinidad.idAfinidad.toString(),
                        "label": d.Afinidad.Nombre + ' (Id: ' + d.Afinidad.idAfinidad.toString() + ') ',
                    }));
                    setAfinidades(optionsAfinidades);


                    let optionsAfinidadesPic = resp['data']['General_Asesores_Afinidades'].map(d => ({
                        "id": d.Afinidad.idAfinidad.toString(),
                        "pic": d.Afinidad.picture
                    }));
                    setCoberturasInfo(resp['data']['CombinadoFamiliar_CoberturasSancor'])
                    setAfinidadesPic(optionsAfinidadesPic)
                    setAutosModulos(resp['data']['Autos_Modulos'])

                    let dictModulos = {};
                    resp['data']['Autos_Modulos'].map((item) => {
                        dictModulos[item.idModulo] = {nombreModulo: item.NombreModulo,}
                    })
                    setDictModulosEmision(dictModulos)
                    setIsReady(true);
                }

            })

        }

        init();
        return () => {
            /* This cleanup function is used to prevent updating the state
            when the component is unmounted */
            shouldUpdate = false;
        };

    }, [])

    const context = useMemo(() => ({
        afinidades,
        localidades,
        afinidadesPic,
        coberturasInfo,
        autosModulos,
        dictModulosEmision,
        TR_ID_MODULOS,
        coveragesToFilter,
        isReady,
    }), [
        afinidades,
        localidades,
        afinidadesPic,
        coberturasInfo,
        autosModulos,
        dictModulosEmision,
        TR_ID_MODULOS,
        coveragesToFilter,
        isReady
    ]);
    return (
        <CotizarContext.Provider value={context}>
            {children}
        </CotizarContext.Provider>
    );
}
CotizarContextProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export default CotizarContextProvider;